export const basePath = "/$__los-ar/";
